import React from 'react';

import { Select, type CustomSelectProps } from '../../../../../components';
import { QUALIFICATION_CHECK_STATUS } from '../../../constants';
import { qualificationCheckOptions } from '../options';
import { type ValidationItem } from './types';

export type QualificationValidationBlockProps = {
  validationItems: ValidationItem[];
  handleBlur: CustomSelectProps['onBlur'];
  handleChange: CustomSelectProps['onChange'];
};
export const QualificationValidationBlock: React.FunctionComponent<
  QualificationValidationBlockProps
> = props => {
  const { validationItems, handleBlur, handleChange } = props;
  const options = qualificationCheckOptions;
  return (
    <div>
      {validationItems.map(
        (
          { label, value, name, error, helperText, readonly = false },
          index,
        ) => {
          const displayValue = value ?? QUALIFICATION_CHECK_STATUS.CHECKING;
          return (
            <div key={index} className="flex !mb-3">
              <div className="basis-1/2">{label}</div>
              <Select
                className="w-3/5 !ml-24"
                disabled={readonly}
                options={options}
                name={name}
                size="small"
                value={displayValue}
                InputLabelProps={{ shrink: true }}
                onBlur={handleBlur}
                onChange={handleChange}
                error={error}
                helperText={helperText}
              />
            </div>
          );
        },
      )}
    </div>
  );
};
